export default {
  title01: "Aktuelles Wetter",
  title02: "24 Stunden",
  title03: "10-Tage-Wettervorhersage anzeigen",
  title04: "AQI",
  title05: "Alle Informationen anzeigen",
  title06: "SONNENAUF- UND UNTERGANG",
  title07: "MONDPHASE",
  title08: "Der nächste Vollmond",
  title09: "Der nächste Neumond",
  title10: "TAG",
  title11: "NACHT",
  title12: "Sonnenaufgang",
  title13: "Sonnenuntergang",
  title14: "Mondaufgang",
  title15: "Monduntergang",
  title16: "Quelle",
  title17: "Start",
  title18: "Ende",
  title19: "Aktuellen Standort verwenden",
  title20: "Stadt suchen",
  title21: "Gefühlte Temperatur",
  title22: "Gefühlte Temperatur im Schatten",
  title23: "Jetzt",
  title24: "Heute",
  title25: "SO",
  title26: "MO",
  title27: "DI",
  title28: "MI",
  title29: "DO",
  title30: "FR",
  title31: "SA",
  title32: "Wird geladen...",
  title33: "Jetzt",
  title34: "Stündlich",
  title35: "Täglich",
  title36: "Sonne und Mond",
  title37: "Luftqualität",
  title38: "Kontakt: xlf550402@gmail.com",
  title39: "Datenschutzerklärung",
  title40: "Urheberrecht © comfortweather.com 2020 - 2025. Alle Rechte vorbehalten.",
  title41: "Daten bereitgestellt von",
  title42: "Max",
  title43: "Min",
  title44: "Akzeptieren",
  title45:
    "Danke, dass Sie ComfortWeather nutzen! Um Ihre gesetzlichen Rechte und Interessen besser zu schützen, lesen Sie bitte die ",
  title46: "Datenschutzrichtlinie",
  title47: " sorgfältig vor der Nutzung.",
  title48: "",
  title49: "Kontakt: xyjph123@gmail.com",
  title50: "Urheberrecht © 24hweather.com 2020 - 2025. Alle Rechte vorbehalten.",
  title51:
    "Danke, dass Sie 24hweather nutzen! Um Ihre gesetzlichen Rechte und Interessen besser zu schützen, lesen Sie bitte die ",
};
